import { Sparkles, Armchair, Camera, Video, Info } from "lucide-react";
import { PageHeader } from "./ServiceDetail";
import { GoldButton, Reveal } from "../components/ui-kit";
import { PARTNER_SERVICES, IMAGES } from "../data/content";

const ICONS = { Sparkles, Armchair, Camera, Video };

export default function ServicesPartenaires() {
  return (
    <div data-testid="partenaires-page">
      <PageHeader overline="Nos services partenaires" title="Un réseau de partenaires sélectionnés" subtitle="Pour simplifier l'organisation de votre événement, KMR Event peut vous mettre en relation avec des partenaires spécialisés dans la décoration, la photographie et la vidéo." image={IMAGES.dining} />
      <section className="pb-24">
        <div className="max-w-6xl mx-auto px-5 sm:px-8">
          <Reveal>
            <div className="glass rounded-xl p-5 flex items-start gap-3 border-gold/20 mb-10">
              <Info size={20} className="text-gold shrink-0 mt-0.5" />
              <p className="text-sm text-muted-foreground">Ces prestations sont proposées ou coordonnées avec des partenaires spécialisés. KMR Event assure directement la musique, le DJing et la location de matériel technique.</p>
            </div>
          </Reveal>
          <div className="grid gap-6 sm:grid-cols-2">
            {PARTNER_SERVICES.map((p, i) => {
              const Icon = ICONS[p.icon];
              return (
                <Reveal key={p.title} delay={i * 0.08}>
                  <div className="glass rounded-2xl p-8 h-full hover:border-gold/40 transition-colors" data-testid="partner-detail-card">
                    <div className="text-gold mb-4"><Icon size={28} /></div>
                    <h2 className="font-serif text-2xl text-foreground">{p.title}</h2>
                    <p className="mt-3 text-muted-foreground leading-relaxed">{p.desc}</p>
                    <span className="inline-block mt-5 text-[11px] uppercase tracking-wider text-gold/70 border border-gold/30 rounded-full px-3 py-1">Proposé avec un partenaire</span>
                  </div>
                </Reveal>
              );
            })}
          </div>
          <div className="text-center mt-14"><GoldButton to="/devis" data-testid="partenaires-devis-btn">Parler de mon projet</GoldButton></div>
        </div>
      </section>
    </div>
  );
}
